var isEmpty = require('./isEmpty');

module.exports = function isTrue(obj){
	return !isEmpty(obj);
}


/*****************
 ** WEBPACK FOOTER
 ** ./lib/isTrue.js
 ** module id = 27
 ** module chunks = 0
 **/